<template>
  <label class="c-checkbox">
    <input type="radio" :name="name" ref="radio" />
    <div class="c-checkbox__text"><slot /></div>
  </label>
</template>

<script>
// @group Base Components
export default {
  name: 'ORadio',
  props: {
    name: String
  }
}
</script>

<style lang="scss">
.c-checkbox {
  align-items: flex-start;
  display: flex;
  margin: 0.8rem 0;

  input[type='radio'] {
    flex: none;
    height: 2.4rem;
    margin: 0 0.8rem 0 0;
    width: 2.4rem;
  }
}

.c-checkbox__text {
  line-height: 2.4rem;
}
</style>
